import { render, staticRenderFns } from "./CardSelector.vue?vue&type=template&id=ba804718&scoped=true&lang=html&"
import script from "./CardSelector.vue?vue&type=script&lang=js&"
export * from "./CardSelector.vue?vue&type=script&lang=js&"
import style0 from "./CardSelector.vue?vue&type=style&index=0&id=ba804718&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba804718",
  null
  
)

export default component.exports